import LazyImage from 'src/utils/lazyImage';
import styled from 'styled-components';

type Props = {
  alt?: string;
  name?: string;
  size: 'xsmall' | 'small' | 'medium' | 'large';
  src: string;
}
export default function Avatar({ alt, name = '', size, src }: Props) {
  return (
    <StyledLazyImage
      alt={alt || `${name} profile image`}
      className={size}
      src={src}
    />
  );
}

const StyledLazyImage = styled(LazyImage)`
  display: inline-block;
  border-radius: 50%;

  &.xsmall {
    width: 28px;
    height: 28px;
  }

  &.small {
    width: 40px;
    height: 40px;
  }

  &.medium {
    width: 60px;
    height: 60px;
  }

  &.large {
    width: 130px;
    height: 130px;
  }
`;
